'use strict';

var version = "0.0.0";

// Default options for the plugin.
var defaults = {
    link: "",
    name: ""
};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-download-video');

    // Create variables and new div, anchor and image for download icon
    var myPlayer = player,
        spacer,
        newElement = document.createElement('div'),
        newLink = document.createElement('a');

    // Assign id and classes to div for icon
    newElement.id = 'downloadButton';
    newElement.className = 'downloadDiv';

    // Assign properties to elements and assign to parents
    newLink.className = 'downloadStyle vjs-control';
    newLink.setAttribute('href', options.link);
    newLink.setAttribute('download', options.name);
    newElement.appendChild(newLink);

    // Get the spacer element
    spacer = myPlayer.controlBar.el();
    // Set the content of the spacer to be right justified
    spacer.setAttribute("style", "justify-content: flex-end;");
    // Place the new element in the spacer
    spacer.appendChild(newElement);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function downloadVideo
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var downloadVideo = function downloadVideo(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('downloadVideo', downloadVideo);

// Include the version number.
downloadVideo.VERSION = version;

module.exports = downloadVideo;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_download/dist/videojs-download-video.cjs.js
// module id = 726
// module chunks = 0